import { ExperienceInsight } from "../types";

/**
 * Reads the experiences an insight applies to from either payload shape:
 * the current prod one (`project_id`, single/nullable) or the migrated one
 * (`project_ids`).
 *
 * TODO: drop the `project_id` fallback once MED-7099 is deployed.
 */
export function getInsightProjectIds(insight: ExperienceInsight): string[] {
  if (insight.project_ids?.length) return insight.project_ids;
  return insight.project_id ? [insight.project_id] : [];
}

// Project-scoped insights when projectId is set, organization-scoped otherwise.
export function getInsightsBaseUrl(
  organizationId: string,
  projectId?: string
): string {
  return projectId
    ? `analytics/projects/${projectId}/insights`
    : `analytics/organizations/${organizationId}/insights`;
}
